module.exports = __webpack_public_path__ + "static/media/moon.8d2a23fe.svg";